module.exports = __webpack_public_path__ + "img/honduras.479bb62e.png";